import { StructuredContentRenderer } from '../renderer';
import type { NodeProps, StructuredContent } from '../types';

export type NerdyTakeawayProps = NodeProps<{
  children: StructuredContent | StructuredContent[];
}>;

/**
 * Article takeaways box. Not the RIA `NerdyTip` callout: white, hairline border, green top rule.
 * Source: NerdWallet/structured-content shared-core/src/components/highlight-boxes/takeaway-box
 * and base-highlight-box.module.less: border-top-3 (base-styles: 4px) green, 1px neutral-lighter,
 * padding 3 (16px) / 4 (28px to 32px fluid) from 768px.
 */
export function NerdyTakeaway({ props }: NerdyTakeawayProps) {
  return (
    <section
      aria-labelledby="nerdy-takeaways-heading"
      className="flex flex-col border border-t-4 border-border border-t-primary bg-background p-4 sm:p-7 lg:p-8"
    >
      <h2 className="typography-text-large-bold mb-4" id="nerdy-takeaways-heading">
        Nerdy takeaways
      </h2>
      <StructuredContentRenderer doc={props.children} />
    </section>
  );
}
